import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar.jsx";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import blogFetch from "../../axios/config";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ModalAddUser from "./RegisterUser";
import UserGroupsModal from "./UserGroupsModal";
import { IUser } from "./UserGroupsInterfaces";
import Context from "../../context/Context";
import language from "../../nls/language.json";

export default function UserPermission() {
  const [users, setUsers] = useState<IUser[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [selectedUser, setSelectedUser] = useState<IUser | undefined>(
    undefined
  );
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      let response = await blogFetch.get("/user?take=1000");
      let data = response.data;
      setUsers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRowClick = (user: IUser) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="d-flex justify-content-end mb-3">
          <Button
            variant="contained"
            onClick={() => {
              setShowModalAdd(true);
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.btnAdicionar}
          </Button>
        </div>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead className="table-header">
            <TableRow>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.tableHeader.nome}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.tableHeader.matricula}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.tableHeader.SAPMatricula}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.tableHeader.email}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.tableHeader.setor}</TableCell>
              <TableCell align="right">{(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.tableHeader.editar}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (                            
              <TableRow
              key={user.user_Id}
              onMouseEnter={() => setHoveredRow(user.user_Id)}
              onMouseLeave={() => setHoveredRow(null)}
              onClick={() => handleRowClick(user)}
              style={{
                cursor: "pointer",
                backgroundColor:
                hoveredRow === user.user_Id ? "#F5F5F5" : "transparent",
              }}
              > 
                <TableCell component="th" scope="row">
                  {user.user_UserName}
                </TableCell>
                <TableCell component="th" scope="row">
                  {user.user_Matricula}
                </TableCell>
                <TableCell component="th" scope="row">
                  {user.user_SAPMatricula}
                </TableCell>
                <TableCell component="th" scope="row">
                  {user.user_Email}
                </TableCell>
                <TableCell component="th" scope="row">
                  {user.sector ? user.sector.stR_description: ""}
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  <ModeEditIcon style={{ alignSelf: "center" }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <UserGroupsModal
        open={showModal}
        onClose={() => setShowModal(false)}
        user={selectedUser}
      />
      <ModalAddUser
        open={showModalAdd}
        onClose={() => setShowModalAdd(false)}
        getUser = {getUsers}
      />
    </>
  );
}
